// ── Column widths (px) ──────────────────────────────────────────────────────
export const RW = {
  manage: 44,
  note: 130,
  companyCost: 120,
  net: 120,
  other: 100,
  late: 100,
  sso: 100,
  tax: 100,
  ssoIncome: 100,
  bonus: 100,
  allow: 100,
  field: 100,
  ot: 100,
  actualNet: 120,
  actualSalary: 100,
  salary: 100,
  dayRate: 82,
  working: 66,
};

// right-offsets for sticky columns
export const R = {
  manage: 0,
  note: RW.manage,
  companyCost: RW.manage + RW.note,
  net: RW.manage + RW.note + RW.companyCost,
  other: RW.manage + RW.note + RW.companyCost + RW.net,
  late: RW.manage + RW.note + RW.companyCost + RW.net + RW.other,
  sso: RW.manage + RW.note + RW.companyCost + RW.net + RW.other + RW.late,
  tax: RW.manage + RW.note + RW.companyCost + RW.net + RW.other + RW.late + RW.sso,
  ssoIncome: RW.manage + RW.note + RW.companyCost + RW.net + RW.other + RW.late + RW.sso + RW.tax,
  bonus: RW.manage + RW.note + RW.companyCost + RW.net + RW.other + RW.late + RW.sso + RW.tax + RW.ssoIncome,
  allow: RW.manage + RW.note + RW.companyCost + RW.net + RW.other + RW.late + RW.sso + RW.tax + RW.ssoIncome + RW.bonus,
  ot: RW.manage + RW.note + RW.companyCost + RW.net + RW.other + RW.late + RW.sso + RW.tax + RW.ssoIncome + RW.bonus + RW.allow,
  salary: RW.manage + RW.note + RW.companyCost + RW.net + RW.other + RW.late + RW.sso + RW.tax + RW.ssoIncome + RW.bonus + RW.allow + RW.ot,
  dayRate: RW.manage + RW.note + RW.companyCost + RW.net + RW.other + RW.late + RW.sso + RW.tax + RW.ssoIncome + RW.bonus + RW.allow + RW.ot + RW.salary,
  working: RW.manage + RW.note + RW.companyCost + RW.net + RW.other + RW.late + RW.sso + RW.tax + RW.ssoIncome + RW.bonus + RW.allow + RW.ot + RW.salary + RW.dayRate,
};

export const LW = { no: 38, name: 210, type: 48 };

// ── Colors ───────────────────────────────────────────────────────────────────
export const BG = {
  headerText: '#111827',
  border: '#E5E7EB',
  borderLight: '#F3F4F6',
  rowEven: '#FFFFFF',
  rowOdd: '#FFFFFF',
  rowHover: '#F9FAFB',
  saturdayBg: '#FFF5F5',
  sundayBg: '#FEE2E2',
  weekendText: '#DC2626',
  footer: '#D1D5DB',
  text: '#1F2937',
  textMuted: '#6B7280',
  subText: '#6B7280',
  hInfo: '#C7D2FE',
  hDays: '#BAE6FD',
  hSum: '#FDE68A',
  hIncome: '#BBF7D0',
  hDeduct: '#FECACA',
  hNet: '#DDD6FE',
  cInfo: '#A5B4FC',
  cDay: '#7DD3FC',
  cSaturday: '#FECACA',
  cSunday: '#FCA5A5',
  cToday: '#FBBF24',
  cSum: '#FCD34D',
  cIncome: '#86EFAC',
  cDeduct: '#FCA5A5',
  cNet: '#C4B5FD',
};

// ── Leave labels / colors ────────────────────────────────────────────────────
export const LEAVE_ABBR = {
  SICK: 'ป่วย',
  PERSONAL: 'กิจ',
  VACATION: 'พร.',
  MATERNITY: 'คลอด',
  ORDINATION: 'บวช',
  UNPAID: 'ไม่รับ',
};

export const LEAVE_COLOR = {
  SICK:       { bg: '#fce7f3', border: '#ec4899', text: '#9d174d' },
  PERSONAL:   { bg: '#ede9fe', border: '#7c3aed', text: '#5b21b6' },
  VACATION:   { bg: '#d1fae5', border: '#059669', text: '#065f46' },
  MATERNITY:  { bg: '#fef9c3', border: '#d97706', text: '#92400e' },
  ORDINATION: { bg: '#ffedd5', border: '#ea580c', text: '#9a3412' },
  UNPAID:     { bg: '#f1f5f9', border: '#64748b', text: '#334155' },
};

export const MONTH_NAMES = [
  'มกราคม', 'กุมภาพันธ์', 'มีนาคม', 'เมษายน',
  'พฤษภาคม', 'มิถุนายน', 'กรกฎาคม', 'สิงหาคม',
  'กันยายน', 'ตุลาคม', 'พฤศจิกายน', 'ธันวาคม',
];

export const DAY_TH_ABBR = ['อา', 'จ', 'อ', 'พ', 'พฤ', 'ศ', 'ส'];

export const RENDER_CHUNK = 8;
